import {
  BillableElement,
  Board,
  CADSources,
} from "../../reducers/uploadedBoard";
import { track } from "@amplitude/analytics-browser";
import { ShoppingCartOrder } from "../../reducers/shoppingCartOrder";
import { BoardEvent } from "../hooks/commonly-stored/uploaded-board/state-machine/sendBoardEvent";

const BOARD_ID_KEY = "Board id";
const CAD_SOURCE_KEY = "CAD source";
const ELEMENT_NAME_KEY = "Element name";

export function trackUploadBoard(boardId: string, cadSource: CADSources) {
  track("Upload board", {
    [BOARD_ID_KEY]: boardId,
    [CAD_SOURCE_KEY]: cadSource,
  });
}

export function trackSawDRCProcessing(board: Board) {
  track("Saw DRC processing", {
    [BOARD_ID_KEY]: board.id,
    [CAD_SOURCE_KEY]: board.cad_source,
  });
}

export function trackSawDRCResults(board: Board) {
  track("Saw DRC results", {
    [BOARD_ID_KEY]: board.id,
    [CAD_SOURCE_KEY]: board.cad_source,
  });
}

export function trackBoardEvent(boardId: string, event: BoardEvent) {
  track(event.event, {
    [BOARD_ID_KEY]: boardId,
    update: event.update,
  });
}

export function trackOpenSelectPartForm(
  board: Board,
  element: BillableElement,
) {
  track("Open select part form", {
    [BOARD_ID_KEY]: board.id,
    [CAD_SOURCE_KEY]: board.cad_source,
    [ELEMENT_NAME_KEY]: element.name,
  });
}

export function trackUploadBillOfMaterials(board: Board) {
  track("Upload bill of materials", {
    [BOARD_ID_KEY]: board.id,
    [CAD_SOURCE_KEY]: board.cad_source,
  });
}

export function trackClickCheckout(shoppingCartOrder: ShoppingCartOrder) {
  const boardIds = shoppingCartOrder.items.map((board) => board.board.id);
  const cadSources = shoppingCartOrder.items.map(
    (board) => board.board.cad_source,
  );

  track("Click checkout", {
    [BOARD_ID_KEY]: boardIds,
    [CAD_SOURCE_KEY]: cadSources,
  });
}

export function trackOrderPlaced(shoppingCartOrder: ShoppingCartOrder) {
  const boardIds = shoppingCartOrder.items.map((board) => board.board.id);
  const cadSources = shoppingCartOrder.items.map(
    (board) => board.board.cad_source,
  );
  track("Placed order", {
    [BOARD_ID_KEY]: boardIds,
    [CAD_SOURCE_KEY]: cadSources,
    Value: shoppingCartOrder.order_total,
    Currency: shoppingCartOrder.currency,
  });
}

export const trackCustomerSawBoardFailed = (
  boardId: string,
  cadSource?: string,
) => {
  track("Customer saw board failed", {
    [BOARD_ID_KEY]: boardId,
    [CAD_SOURCE_KEY]: cadSource,
  });
};

export const trackBoardFailed = (boardId: string | undefined) => {
  track("Board failed", {
    [BOARD_ID_KEY]: boardId,
  });
};
